"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const template_1 = __importDefault(require("./template"));
class Overlay {
    constructor({ windowOpener, overlayContent, onOverlayClick, onOverlayClose, previousActiveElement, popupUrl, }) {
        this.popup = null;
        this.windowOpener = windowOpener;
        this.overlayContent = overlayContent;
        this.onOverlayClick = onOverlayClick;
        this.onOverlayClose = onOverlayClose;
        this.previousActiveElement = previousActiveElement;
        this.lastPopupUrl = popupUrl ?? 'about:blank';
        Overlay.ACTIVE_OVERLAY = this;
    }
    createShadowRoot() {
        const shadowRootElement = this.windowOpener.document.createElement('div');
        shadowRootElement.setAttribute('id', 'klarna-fullscreen-shadow-dom');
        this.windowOpener.document.body.append(shadowRootElement);
        // Appending empty span to shadow root to fix browser misinterpretation of empty div
        const emptySpan = this.windowOpener.document.createElement('span');
        shadowRootElement.append(emptySpan);
        const shadowRoot = shadowRootElement.attachShadow({ mode: 'open' });
        return shadowRoot;
    }
    create() {
        this.root = this.createShadowRoot();
        this.root.innerHTML = (0, template_1.default)(this.overlayContent?.text, this.overlayContent?.buttonLabel, this.overlayContent?.iframe);
        this.overlay = this.root.querySelector('.overlay-open');
        const closeButtonElement = this.overlay.querySelector('#overlay-close-button');
        document.body.style.overflow = 'hidden';
        const onCloseClick = (clickEvent) => {
            clickEvent.stopPropagation();
            this.destroy();
        };
        this.overlay.addEventListener('click', this.onOverlayClick);
        this.removeOverlayClickListener = () => {
            this.overlay?.removeEventListener('click', this.onOverlayClick);
        };
        closeButtonElement?.addEventListener('click', (evt) => onCloseClick(evt));
        this.removeOverlayCloseButtonListener = () => {
            closeButtonElement?.removeEventListener('click', (evt) => onCloseClick(evt));
        };
    }
    updateDOM() {
        this.root.innerHTML = (0, template_1.default)(this.overlayContent?.text, this.overlayContent?.buttonLabel, this.overlayContent?.iframe);
    }
    update({ windowOpener, overlayContent, onOverlayClick, onOverlayClose, previousActiveElement, popupUrl, }) {
        this.windowOpener = windowOpener;
        this.overlayContent = overlayContent;
        this.onOverlayClick = onOverlayClick;
        this.onOverlayClose = onOverlayClose;
        this.previousActiveElement = previousActiveElement;
        this.lastPopupUrl = popupUrl ?? 'about:blank';
        this.updateDOM();
    }
    getIframe() {
        return this.root?.querySelector('iframe');
    }
    destroy() {
        const OVERLAY_CLOSE_ANIMATION_CLASS = 'overlay-close';
        const OVERLAY_FADE_TIMEOUT = 350;
        this.overlay?.classList.add(OVERLAY_CLOSE_ANIMATION_CLASS);
        if (this.onOverlayClose) {
            this.onOverlayClose();
        }
        if (this.removeOverlayClickListener) {
            this.removeOverlayClickListener();
        }
        if (this.removeOverlayCloseButtonListener) {
            this.removeOverlayCloseButtonListener();
        }
        this.destroyPopup();
        Overlay.ACTIVE_OVERLAY = null;
        document.body.style.overflow = '';
        setTimeout(() => {
            this.root?.host?.parentNode?.removeChild(this.root?.host);
            this.previousActiveElement?.focus();
        }, OVERLAY_FADE_TIMEOUT);
    }
    hide() {
        const OVERLAY_CLOSE_ANIMATION_CLASS = 'overlay-close';
        const OVERLAY_FADE_TIMEOUT = 350;
        this.overlay?.classList.add(OVERLAY_CLOSE_ANIMATION_CLASS);
        if (this.removeOverlayClickListener) {
            this.removeOverlayClickListener();
        }
        if (this.removeOverlayCloseButtonListener) {
            this.removeOverlayCloseButtonListener();
        }
        Overlay.ACTIVE_OVERLAY = null;
        document.body.style.overflow = '';
        setTimeout(() => {
            this.root?.host?.parentNode?.removeChild(this.root?.host);
            this.previousActiveElement?.focus();
        }, OVERLAY_FADE_TIMEOUT);
    }
    connectPopup(popup) {
        this.popup = popup;
    }
    destroyPopup() {
        if (this.popup && !this.popup.closed) {
            this.popup.close();
        }
        this.popup = null;
    }
    /*
     * Overlay can keep track of the last url the integrator tried to open in case the
     * keepOverlayOpen flag is set and the default onClickOverlay behavior is to try to reopen the popup
     */
    updateLastPopupUrl(newUrl) {
        this.lastPopupUrl = newUrl;
    }
    getLastPopupUrl() {
        return this.lastPopupUrl;
    }
    getPopupWindow() {
        return this.popup;
    }
}
Overlay.ACTIVE_OVERLAY = null;
exports.default = Overlay;
